import React from "react";
import { format } from "date-fns";
import {
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
} from "@mui/lab";
import getIconForLog from "./logIcons";
import { Typography, Avatar } from "@mui/material";

const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    return {
        date: format(date, "MMM d, yyyy"),
        time: format(date, "hh:mm a"),
    };
};

const HistoryTab = ({ logs }) => {
    if (!logs || logs.length === 0) {
        return <Typography>No history available.</Typography>;
    }

    return (
        <Timeline position="alternate">
            {logs.map((log, idx) => {
                const { date, time } = formatDateTime(log.date_logged);
                const logType = (log.message?.toLowerCase().split(" ")[0]) || "default";
                const iconObj = getIconForLog(log.message);
                const Icon = iconObj?.icon;

                const colorOverride = {
                    updated: "#2196f3", // blue
                    email: "#4caf50",   // green
                    created: "#00bcd4", // cyan
                    archived: "#f44336", // red
                    locked: "#ff9800",  // orange
                    added: "#9c27b0",   // purple
                    removed: "#f44336", // red
                    default: "#9e9e9e", // grey
                }[logType] || "#9e9e9e";

                return (
                    <TimelineItem key={idx}>
                        <TimelineSeparator>
                            <TimelineDot color="grey" sx={{ bgcolor: colorOverride }}>
                                {Icon && <Icon fontSize="small" />}
                            </TimelineDot>
                            {idx !== logs.length - 1 && <TimelineConnector />}
                        </TimelineSeparator>

                        <TimelineContent sx={{ textAlign: "left" }}>
                            {/* Staff avatar and name */}
                            {log.staff_name && (
                                <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                                    <Avatar
                                        sx={{
                                            width: 28,
                                            height: 28,
                                            fontSize: 12,
                                            marginRight: 1,
                                            bgcolor: "#2196f3",
                                            color: "#fff",
                                        }}
                                    >
                                        {log.staff_name
                                            .split(" ")
                                            .map((word) => word[0])
                                            .join("")
                                            .toUpperCase()}
                                    </Avatar>
                                    <Typography variant="caption" sx={{ color: "#ccc" }}>
                                        {log.staff_name}
                                    </Typography>
                                </div>
                            )}

                            <Typography variant="body2" fontWeight="bold" sx={{ color: "#2196f3" }}>
                                {date}
                            </Typography>
                            <Typography variant="caption" sx={{ color: "#2196f3" }}>
                                {time}
                            </Typography>

                            {/* HTML-safe message rendering */}
                            {/<[a-z][\s\S]*>/i.test(log.message) ? (
                                <Typography
                                    variant="body1"
                                    mt={1}
                                    dangerouslySetInnerHTML={{ __html: log.message }}
                                />
                            ) : (
                                <Typography variant="body1" mt={1}>
                                    {log.message}
                                </Typography>
                            )}
                        </TimelineContent>
                    </TimelineItem>
                );
            })}
        </Timeline>
    );
};

export default HistoryTab;
